import { render, staticRenderFns } from "./Compose.vue?vue&type=template&id=f0ee0894&scoped=true&"
import script from "./Compose.vue?vue&type=script&lang=ts&"
export * from "./Compose.vue?vue&type=script&lang=ts&"
import style0 from "./Compose.vue?vue&type=style&index=0&id=f0ee0894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ee0894",
  null
  
)

export default component.exports